<template>
  <div class="exhibition">
    <div class="container">
      <div class="block1">
        <img
          src="../../assets/exhibition-bj/imgsMobile/001.jpg"
          style="width: 100%;pointer-events:none;"
        />
      </div>
      <div class="block2">
        <img
          src="../../assets/exhibition-bj/imgsMobile/002.jpg"
          style="width: 100%;pointer-events:none;"
        />
      </div>
      <div class="block3">
        <img
          src="../../assets/exhibition-bj/imgsMobile/003.jpeg"
          style="width: 100%;pointer-events:none;"
        />
      </div>
      <!-- <div
        class="block4"
        onclick="window.location='https://www.csvw.com/csvw-website/news/dz-brand-news.html?newsid=2843'"
      >
        <img
          src="../../assets/exhibition-bj/imgsMobile/004.jpg"
          style="width: 100%;pointer-events:none;"
        />
      </div>
      <div
        class="block6"
        onclick="window.location='https://www.csvw.com/csvw-website/news/skoda-brand-news.html?newsid=2845'"
      >
        <img
          src="../../assets/exhibition-bj/imgsMobile/006.jpg"
          style="width: 100%;pointer-events:none;"
        />
      </div>-->
      <div class="block6" v-for="(item,index) in zixunlist" :key="index" @click="toUrl(item.tourl)">
        <img :src="item.url" style="width: 100%;pointer-events:none;" />
      </div>
      <div class="block7">
        <img src="../../assets/exhibition-bj/imgsMobile/007.jpeg" style="width: 100%;" />
      </div>
      <div class="block8">
        <div class="block" style="margin-top:0px;">
          <!-- <div class="title">大众品牌车型</div> -->
          <div class="contain" style="margin-top:0px;">
            <div class="img" v-for="(item,index) in picsArr" :key="index" @click="showPop(index)">
              <img alt="xxx" :src="item.url" style="width: 100%;" />
            </div>

            <!-- <div class="img" onclick="window.location='https://www.csvw.com/svwmedia-website/media/teramont.html?contentId=24755'">
              <img
                alt="xxx"
                src="../../assets/exhibition-bj/imgsMobile/301.jpg"
                style="width: 100%;"
              />
            </div>
            <div class="img" onclick="window.location='https://www.csvw.com/svwmedia-website/media/teramont.html?contentId=24095'">
              <img
                alt="xxx"
                src="../../assets/exhibition-bj/imgsMobile/302.jpg"
                style="width: 100%;"
              />
            </div>
            <div class="img" onclick="window.location='https://www.csvw.com/svwmedia-website/media/teramont.html?contentId=20019'">
              <img
                alt="xxx"
                src="../../assets/exhibition-bj/imgsMobile/303.jpg"
                style="width: 100%;"
              />
            </div>
            <div class="img" onclick="window.location='https://www.csvw.com/svwmedia-website/media/teramont.html?contentId=24287'">
              <img
                alt="xxx"
                src="../../assets/exhibition-bj/imgsMobile/304.jpg"
                style="width: 100%;"
              />
            </div>-->

            <!-- <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/305.jpg" style="width: 100%;" />
              <div class="text">Tharu 途岳</div>
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/306.jpg" style="width: 100%;" />
              <div class="text">T-Cross 途铠</div>
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/307.jpg" style="width: 100%;" />
              <div class="text">PHIDEON 辉昂</div>
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/308.jpg" style="width: 100%;" />
              <div class="text">New Passat 全新一代帕萨特</div>
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/309.jpg" style="width: 100%;" />
              <div class="text">New Lamando 全新凌渡</div>
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/310.jpg" style="width: 100%;" />
              <div class="text">All New Lavida 全新一代朗逸</div>
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/311.jpg" style="width: 100%;" />
              <div class="text">New Santana 新桑塔纳</div>
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/312.jpg" style="width: 100%;" />
              <div class="text">All New Polo Plus 全新一代 Polo Plus</div>
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/313.jpg" style="width: 100%;" />
              <div class="text">Passat PHEV 帕萨特插电式混合动力版</div>
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/314.jpg" style="width: 100%;" />
              <div class="text">Tiguan L PHEV 途观L插电式混合动力版</div>
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/315.jpg" style="width: 100%;" />
              <div class="text">e-Lavida 朗逸纯电</div>
            </div> 
            <div class="left">
              <img alt="xxx" src="../../assets/exhibition/imgsMobile/101.png" style="width: 100%;" />
            </div>
            <div class="right">
              <img alt="xxx" src="../../assets/exhibition/imgsMobile/102.png" style="width: 100%;" />
            </div>-->
          </div>
        </div>
        <!-- <div class="block">
          <div class="title">斯柯达品牌车型</div>
          <div class="contain">
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/401.jpg" style="width: 100%;" />
              <div class="text">KODIAQ 柯迪亚克</div>
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/402.jpg" style="width: 100%;" />
              <div class="text">KAROQ 柯珞克智行款</div>
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/403.jpg" style="width: 100%;" />
              <div class="text">KAMIQ 柯米克</div>
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/404.jpg" style="width: 100%;" />
              <div class="text">KODIAQ GT 柯迪亚克GT</div>
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/405.jpg" style="width: 100%;" />
              <div class="text">KAMIQ GT 柯米克GT</div>
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/406.jpg" style="width: 100%;" />
              <div class="text">SUPERB 速派</div>
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/407.jpg" style="width: 100%;" />
              <div class="text">OCTAVIA 明锐智行款</div>
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/408.jpg" style="width: 100%;" />
              <div class="text">RAPID 昕锐</div>
            </div>
          </div>
          <div class="left">
            <img alt="xxx" src="../../assets/exhibition/imgsMobile/101.png" style="width: 100%;" />
          </div>
          <div class="right">
            <img alt="xxx" src="../../assets/exhibition/imgsMobile/102.png" style="width: 100%;" />
          </div>
        </div>
        <div class="block">
          <div class="title">车展花絮</div>
          <div class="contain">
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/501.jpg" style="width: 100%;" />
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/502.jpg" style="width: 100%;" />
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/503.jpg" style="width: 100%;" />
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/504.jpg" style="width: 100%;" />
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/505.jpg" style="width: 100%;" />
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/506.jpg" style="width: 100%;" />
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/507.jpg" style="width: 100%;" />
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/508.jpg" style="width: 100%;" />
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/509.jpg" style="width: 100%;" />
            </div>
          </div>
          <div class="left2">
            <img alt="xxx" src="../../assets/exhibition/imgsMobile/101.png" style="width: 100%;" />
          </div>
          <div class="right2">
            <img alt="xxx" src="../../assets/exhibition/imgsMobile/102.png" style="width: 100%;" />
          </div>
        </div>-->

        <div class="cover" v-if="showCover"></div>
        <div class="popup" v-if="showCover" style="width:350px;height:250px">
          <div>
            <div class="close" @click="closePop()">
              <img alt="xxx" src="../../assets/exhibition/imgs/106.png" style="width: 100%;" />
            </div>
            <div class="img">
              <el-carousel
                indicator-position="none"
                :autoplay="false"
                arrow="always"
                style="width: 100%;"
                height="220px"
              >
                <el-carousel-item v-for="(item,index) in picsArrImg[picsArrIndex]" :key="index">
                  <div v-if="item.type==2">
                    <video
                      preload="auto"
                      controls
                      controlslist="nodownload"
                      :disablePictureInPicture="true"
                      type="video/mp4"
                      :src="item.url"
                      style="width: 100%;"
                    >
                      <source
                        :src="item.url"
                        type="video/mp4"
                      />
                    </video>
                  </div>
                  <div v-if="item.type==1">
                    <img :src="item.url" style="width: 100%;" />
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "./config";
export default {
  name: "ExhibitionMobile",
  data() {
    return {
      isPhone: false,
      // 咨询列表
      zixunlist: [
        {
          url: require("../../assets/exhibition-bj/imgsMobile/201.jpg"),
          tourl:
            "https://www.csvw.com/csvw-website/news/company-news.html?newsid=2851"
        },
        {
          url: require("../../assets/exhibition-bj/imgsMobile/202.jpg"),
          tourl:
            "https://www.csvw.com/csvw-website/news/dz-brand-news.html?newsid=2847"
        },
        {
          url: require("../../assets/exhibition-bj/imgsMobile/203.jpg"),
          tourl:
            "https://www.csvw.com/csvw-website/news/skoda-brand-news.html?newsid=2850"
        },
        {
          url: require("../../assets/exhibition-bj/imgsMobile/204.jpg"),
          tourl:
            "https://www.csvw.com/csvw-website/news/dz-brand-news.html?newsid=2849"
        },
        {
          url: require("../../assets/exhibition-bj/imgsMobile/205.jpg"),
          tourl:
            "https://www.csvw.com/csvw-website/news/dz-brand-news.html?newsid=2848"
        }
      ],
      picsArr: [
        {
          url: require("../../assets/exhibition-bj/imgsMobile/301.jpg")
        },
        {
          url: require("../../assets/exhibition-bj/imgsMobile/302.jpg")
        },
        {
          url: require("../../assets/exhibition-bj/imgsMobile/311.jpeg")
        },
        {
          url: require("../../assets/exhibition-bj/imgsMobile/312.jpeg")
        },
        {
          url: require("../../assets/exhibition-bj/imgsMobile/321.jpeg")
        },
        {
          url: require("../../assets/exhibition-bj/imgsMobile/322.jpeg")
        },
        {
          url: require("../../assets/exhibition-bj/imgsMobile/331.jpeg")
        }
      ],
      showCover: false,
      picsArrIndex: 0,
      picsArrImg: config.picsArrImg
    };
  },
  mounted: function() {},
  methods: {
    showPop(url) {
      this.showCover = true;
      this.picsArrIndex = url;
    },
    toUrl(url) {
      window.location = url;
    },
    closePop() {
      this.showCover = false;
    }
  }
};
</script>

<style scoped>
.block8 {
  margin-bottom: 30px;
}
.block {
  position: relative;
  width: 100%;
  margin-top: 20px;
}
.contain {
  margin-top: 20px;
}
.block .title {
  font-size: 14px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 14px;
  text-align: center;
}
.block .contain {
  /* white-space: nowrap;  */
  /*文本不会换行，文本会在在同一行上继续*/
  /* overflow-x: auto;  */
  /*可滑动*/
}
/*自定义滚动条的伪对象选择器, CSS 可以隐藏滚动条*/
/*.block ::-webkit-scrollbar {*/
/*  display: none;*/
/*}*/
.block .contain .img {
  width: 100%;
  /* margin-left: 3%; */
  /*display: inline-block;*/ /*行内块元素*/
  /* vertical-align: top; */
}
.block .contain .text {
  margin-top: 10px;
  text-align: center;
  font-size: 12px;
  color: rgba(51, 51, 51, 1);
}
.block .left {
  position: absolute;
  top: 43%;
  left: 5%;
  width: 20px;
  height: 28px;
}
.block .right {
  position: absolute;
  top: 43%;
  right: 5%;
  width: 20px;
  height: 28px;
}
.block .left2 {
  position: absolute;
  top: 50%;
  left: 5%;
  width: 20px;
  height: 28px;
}
.block .right2 {
  position: absolute;
  top: 50%;
  right: 5%;
  width: 20px;
  height: 28px;
}
.block1 {
  /* background-image: url("../../assets/exhibition-bj/imgsMobile/001.jpg");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding-bottom: 100%; */
}
.block2 {
  /* background-image: url("../../assets/exhibition-bj/imgsMobile/002.jpg");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding-bottom: 100%; */
}
.block3 {
  /* background-image: url("../../assets/exhibition-bj/imgsMobile/003.jpg");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding-bottom: 100%; */
}
.block4 {
  /* background-image: url("../../assets/exhibition-bj/imgsMobile/004.jpg");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding-bottom: 100%; */
}
.block5 {
  /* background-image: url("../../assets/exhibition/imgsMobile/005.jpg");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding-bottom: 100%; */
}
.block6 {
  /* background-image: url("../../assets/exhibition-bj/imgsMobile/006.jpg");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding-bottom: 100%; */
}
.block7 {
  /* background-image: url("../../assets/exhibition/imgsMobile/007.jpg");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding-bottom: 100%; */
}

.block8 .cover {
  position: fixed;
  /*首先将位置固定住*/
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  /*上下左右设置都为0*/
  background: rgba(2, 2, 2, 0.5);
}
.block8 .popup {
  position: fixed;
  margin: auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 350px;
  height: 400px;
}
.block8 .popup .close {
  position: relative;
  float: right;
  width: 20px;
  cursor: pointer;
}
</style>